<template>
  <b-modal v-if="claimFailure" ref="claimModal" size="lg" hide-footer centered>
    <loading v-bind:active.sync="loading"></loading>
    <template v-slot:modal-title>
      <h5>This house is already claimed...</h5>
    </template>
    <p>According to our Terms of Use you can only claim houses that you own.<br/>
       <br/>
       A request will be sent to the current owner who will have 15 days to respond.  If you have any questions or concerns, email support@homapt.com.<br/>
       <br/>
       Do you want to move forward with your request to claim this house?
    </p>
    <div class="container">
      <div class="row">
        <div class="col-4 offset-2">
          <button class="btn btn-primary" v-on:click="claimHome()">Yes</button><!-- Change function called when implemented -->
        </div>
        <div class="col-4">
          <button class="btn btn-secondary" v-on:click="$refs.claimModal.hide(); claimFailure = false">No</button>
        </div>
      </div>
    </div>
  </b-modal>
  <b-modal v-else ref="claimModal" size="lg" hide-footer centered>
    <loading v-bind:active.sync="loading"></loading>
    <template v-slot:modal-title>
      <h5>Are you sure you want to claim this house?</h5>
    </template>
    <p>What happens when you claim your house?<br/>
       ~ Access to store receipts and create HomFAXs about your house that only you can see<br/>
       ~ No one else can claim your house or see your owner information<br/>
       ~ Update your HomFAX to add value to your home<br/>
       ~ Get valuable tax documents when you sell your house<br/>
       <br/>
       According to our Terms of Use, you can only claim houses you own.
    </p>
    <div class="container">
      <div class="row">
        <div class="col-4 offset-2">
          <button class="btn btn-primary" v-on:click="claimHome()">Yes</button>
        </div>
        <div class="col-4">
          <button class="btn btn-secondary" v-on:click="$refs.claimModal.hide()">Close</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import router from '../../../../router/index.js'

export default {
  components: {
    Loading
  },
  data () {
    return {
      claimFailure: false,
      loading: false
    }
  },
  props: {
    house: Object
  },
  methods: {
    ...mapActions('user', [
      'getCurrentUserData',
      'putUserData'
    ]),
    ...mapMutations('user', [
      'addClaimedHouse'
    ]),
    async claimHome () {
      this.loading = true
      try {
        var client = this.$store.getters.getPropertyApigClientFactory
        var body = this.house.toSimpleObject()
        var params = {unique_id: body.unique_id}
        var pathTemplate = '/properties/{unique_id}'
        var method = 'POST'
        var additionalParams = {}
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        if (result.status === 201) {
          await this.getCurrentUserData()
          this.addClaimedHouse(body.unique_id)
          await this.putUserData()
          router.push('/property/' + body.unique_id)
        } else {
          console.log('House not claimed.')
        }
      } catch (error) {
        if (error.response.status === 403) this.claimFailure = true
        console.log(error)
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.btn {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/rightSide/ClaimModal.vue